
/* injects from baggage-loader */

'use strict';

export default class ProjectEditorController {

	constructor($log, $timeout, $state, $document, Alerts, Countries, Parse, ProjectSubmission) {
		'ngInject';

		this.$log = $log;
		this.$timeout = $timeout;
		this.$state = $state;
		this.$document = $document;
		this.Alerts = Alerts;
		this.Parse = Parse;
		this.ProjectSubmission = ProjectSubmission;

		// Set countries filtered to only the US and Canada
		this.countries = Countries.filter(country => ['US', 'CA'].includes(country.code));

		// Set date picker options
		this.dateOpts = {
			altInput: true,
			altFormat: "F j, Y",
			dateFormat: "Z"
		};

		// Initialize view flags
		this.savingProject = false;

	}

	$onInit() {
		
		// Select the first section
		this.selectInfoSection(this.sections[0]);
		this.selectPledgeReward(this.rewards[0]);

	}


	/**
	 * Called when flatpicker is initialized, sets up the date according to ng-model
	 * @param {Object} fpItem 
	 * @param {Object} options 
	 */
	datePostSetup(fpItem, options) {
		fpItem.setDate(options.date);
	}

	selectInfoSection(section) {
		this.sections.forEach(s => s.selected = false);
		section.selected = true;
		this.selectedSection = section;
	}

	selectPledgeReward(reward) {
		this.rewards.forEach(s => s.selected = false);
		reward.selected = true;
		this.selectedReward = reward;
	}


	saveProject() {
		this.$log.log(this.project)

		this.savingProject = true;

		this.project.save().then(() => {
			alert('saved')
			this.savingProject = false;
			this.$timeout();
		})
	}

}



// WEBPACK FOOTER //
// ./src/app/pages/project-editor/project-editor.controller.js